<template>
  <div>
    <qb-table>
      <template v-slot:thead>
        <qb-tr style="width: 100%">
          <qb-th class="f-14">
            {{ $t('client') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $tc('position_title') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('departament') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('aging') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('shift') | capitalize }}
          </qb-th>
          <qb-th class="text-center f-14">
            {{ $t('hired') | capitalize }}
          </qb-th>
          <qb-th class="text-center f-14">
            {{ $t('required') | capitalize }}
          </qb-th>
          <qb-th class="text-center f-14">
            {{ $t('difference') | capitalize }}
          </qb-th>
          <qb-th class="text-center f-14">
            {{ $t('progress') | capitalize }}
          </qb-th>
          <qb-th class="f-14">
            {{ $t('status') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 10px"></qb-th>
        </qb-tr>
      </template>
      <template v-slot:tbody>
        <!-- <qb-tr v-for="(el, idx) in data" :key="idx"> -->
        <qb-tr v-for="(el, idx) in data" :key="idx">
          <qb-td>{{ el.ClientName | capitalize }}</qb-td>
          <qb-td>{{ el.Position | capitalize }}</qb-td>
          <qb-td>{{ el.facility | upperCase }}</qb-td>
          <qb-td>{{ el.aging | upperCase }}</qb-td>
          <qb-td>{{ el.Shift | upperCase }}</qb-td>
          <qb-td class="text-center">{{ el.Hired | upperCase }}</qb-td>
          <qb-td class="text-center text-warning">{{ el.Required | upperCase }}</qb-td>
          <qb-td class="text-center text-danger">{{ (el.Hired - el.Required )}}</qb-td>
          <qb-td class="text-center">
            <vs-progress :height="12" :percent="getProgress(el.Hired,el.Required)" color="warning"></vs-progress>
          </qb-td>
          <qb-td class="text-center">
            <vs-chip :color="el.status_color" class="chip-status text-center w-full">
              {{ el.status_name | upperCase }}
            </vs-chip>
          </qb-td>
          <qb-td>
            <action-icon
              icon="EditIcon"
              :tooltip="$t('edit') | capitalize"
              @click="openModal(el.id)"
          /></qb-td>
        </qb-tr>
        <qb-tr>
          <qb-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </qb-td>
        </qb-tr>
      </template>
    </qb-table>
  </div>
</template>

<script>
import QbTable from '@/views/qb-components/table/QbTable.vue'
import QbTr from '@/views/qb-components/table/QbTr.vue'
import QbTh from '@/views/qb-components/table/QbTh.vue'
import QbTd from '@/views/qb-components/table/QbTd.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  name: 'direct-table',
  components: {
    ActionIcon,
    QbTable,
    QbTr,
    QbTh,
    QbTd,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getProgress(hired,required){
      if(hired == 0 || required == 0 ){
        return 0
      }
      return (hired * 100) / required
    },
    openModal(id) {
      this.$emit('openModal', id)
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
  },
}
</script>

<style>
.chip-status {
  max-width: 9rem;
  min-width: 2rem;
  color: white;
  text-align: center;
  border-radius: 0.3em;
}
</style>
